import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { SlPencil } from "react-icons/sl";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ModalAlt from "../../components/modal/ModalAlt";
import { ERROR_MSG, ROLE } from "../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../constants/contexConstant";
import { connectionTypeToCategory } from "../../constants/InvestmentConstant";
import {
    CURRENT_MASTER_DATA_ENDPOINT,
    GET_SALES_SURVEYOR_ASSIGNEE_INFO,
    SALES_PROPOSAL_BASE_ENDPOINT,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import { checkIsAllowed, getURLQueryParams } from "../../helpers/helpers";
import cn from "../../lib/cn";
import { locationLight, statusImages } from "../../resources/js/icons";
import request from "../../services/request";
import Counter from "../../shared/animation/typography/Counter";
import Container from "../../shared/Container";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";
import TextField from "../../shared/ui/Form/TextField";
import Tag from "../../shared/ui/tag/Tag";
import AdditionalInput from "./AdditionalInput";
import GenerateProposal from "./GenerateProposal";
import ProposalTable from "./ProposalTable";
import ReAssignForm from "./ReAssignForm";

const PropertyContent = ({ propertyName, setDis, formData, propertyId }) => {
    const location = useLocation();
    const current = Number(getURLQueryParams(location, "current")) || 0;
    const [surveyDate, SetSurveyDate] = useState();
    const { state, dispatch } = useContextState();
    const [currentTab, setCurrentTab] = useState(current);
    const [selectedConnectionType, setSelectedConnectionType] = useState(
        connectionTypeToCategory.RESIDENTIAL_SOCIETY
    );
    const [details, setDetails] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const [solarData, setSolarData] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [consumersBill, setConsumersBill] = useState(null);
    const [totalUnits, setTotalUnits] = useState("");
    const [isProposalGenerated, setIsProposalGenerated] = useState(false);
    const [subsidy, setSubsidy] = useState(false);
    const [plan, setPlan] = useState(5);
    const initialCheckedState =
        selectedConnectionType === connectionTypeToCategory.RESIDENTIAL_SOCIETY
            ? { purchase: true, lease: true }
            : selectedConnectionType ===
                  connectionTypeToCategory.INDIVIDUAL_HOMES ||
              selectedConnectionType === connectionTypeToCategory.INDUSTRIAL
            ? { purchase: true, loan: true }
            : { purchase: true, lease: true, loan: true };

    const [checkedState, setCheckedState] = useState(initialCheckedState);
    const selectedOptions = Object.keys(checkedState)
        .filter((key) => checkedState[key])
        .map((option) => option.charAt(0).toUpperCase() + option.slice(1));

    const handleCheckboxChange = (key) => {
        const checkedCount = Object.values(checkedState).filter(Boolean).length;

        if (checkedCount === 1 && checkedState[key]) {
            toast.warn("At least one option must remain selected.");
            return;
        }
        setCheckedState((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const isServerCalculation =
        selectedConnectionType ===
            connectionTypeToCategory.RESIDENTIAL_SOCIETY ||
        selectedConnectionType === connectionTypeToCategory.INDIVIDUAL_HOMES;

    const fetchBillAmount = useCallback(async () => {
        try {
            dispatch(SET_LOADER);
            if (isServerCalculation && !isNaN(totalUnits)) {
                let res = await request.authGet({
                    endpoint: `${SALES_PROPOSAL_BASE_ENDPOINT}/getBill/residential/${totalUnits}`,
                });
                let bill = res?.data?.billAmount.toFixed(2);
                if (bill) {
                    setConsumersBill(bill);
                } else {
                    toast.error(
                        "Can't fetch bill amount. Please try again later"
                    );
                }
            }
            dispatch(RESET_LOADER);
        } catch (error) {
            dispatch(RESET_LOADER);
        }
    }, [isServerCalculation, totalUnits, dispatch]);

    const handleConnectionTypeChange = (selected) => {
        setSelectedConnectionType(selected);
    };

    const handleTotalUnitsChange = (e) => {
        setTotalUnits(e.target.value);
    };
    const handleConsumerBill = (e) => {
        setConsumersBill(e.target.value);
    };
    useEffect(() => {
        fetchBillAmount();
    }, [totalUnits, fetchBillAmount]);

    const fetchData = async () => {
        try {
            dispatch({ type: SET_LOADER });
            const endpoint = CURRENT_MASTER_DATA_ENDPOINT;
            const data = await request.authGet({ endpoint });
            dispatch({ type: RESET_LOADER });
            setSolarData(JSON.parse(data.data.masterData.data));
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };
    const fetchDetails = async () => {
        try {
            dispatch({ type: SET_LOADER });
            let res = await request.authGet({
                endpoint: `${GET_SALES_SURVEYOR_ASSIGNEE_INFO}/${propertyId}`,
            });
            let response = res?.data?.data;
            setDetails(response);
            SetSurveyDate(response?.surveyDate);
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };

    useEffect(() => {
        setCheckedState(
            selectedConnectionType ===
                connectionTypeToCategory.RESIDENTIAL_SOCIETY
                ? { purchase: true, lease: true }
                : selectedConnectionType ===
                      connectionTypeToCategory.INDIVIDUAL_HOMES ||
                  selectedConnectionType === connectionTypeToCategory.INDUSTRIAL
                ? { purchase: true, loan: true }
                : { purchase: true, lease: true, loan: true }
        );
    }, [selectedConnectionType]);

    const generateProposal = (values) => {
        setSubsidy(values.subsidy === "Yes");
        setPlan(values?.planDuration);
        setIsProposalGenerated(true);
    };

    const [showAdditionalModal, setShowAdditionalModal] = useState(false);
    const [additionalInput, setAdditionalInputs] = useState([]);

    const onQuitModal = () => {
        setAdditionalInputs([]);
    };
    useEffect(() => {
        fetchData();
        fetchDetails();
    }, []);

    const surveyD = moment(surveyDate * 1000).format("DD/MM/yyyy hh:m");
    return (
        <div className="px-0 min-w-full mx-0 lg:container  lg:min-w-fit font-vietnam lg:mb-4">
            <div
                className={cn(
                    "bg-white min-h-svh lg:min-h-full  rounded-t-2.5 lg:rounded-none items-stretch p-1   flex flex-col lg:flex-row gap-1.6 ",
                    {
                        "bg-transparent p-0": isProposalGenerated,
                    }
                )}
            >
                <Container className={cn("min-w-full md:px-4 lg:hidden")}>
                    {isProposalGenerated && (
                        <div className="flex justify-between items-center mb-2">
                            {selectedOptions.map((option, index) => (
                                <div
                                    key={option}
                                    role="button"
                                    onClick={() => setCurrentSlide(index)}
                                >
                                    <P
                                        className={cn(
                                            "text-gray-370 flex items-center gap-1",
                                            {
                                                "text-white border-b-2 border-b-blue pb-1 font-medium":
                                                    currentSlide === index,
                                            }
                                        )}
                                    >
                                        {option}
                                    </P>
                                </div>
                            ))}
                        </div>
                    )}

                    <div
                        className={cn(
                            "flex lg:hidden justify-between items-center border-b border-b-blue-250 my-1",
                            {
                                hidden: isProposalGenerated,
                            }
                        )}
                    >
                        <div
                            role="button"
                            onClick={() => {
                                setCurrentTab(0);
                            }}
                            className={cn("pb-2", {
                                "border-b-2 border-b-blue ": currentTab === 0,
                            })}
                        >
                            <P
                                className={cn("text-nowrap", {
                                    "text-blue font-medium": currentTab === 0,
                                })}
                            >
                                Generate Proposal
                            </P>
                        </div>
                        <div
                            role="button"
                            onClick={() => {
                                setCurrentTab(1);
                            }}
                            className={cn("pb-2", {
                                "border-b-2 border-b-blue ": currentTab === 1,
                                hidden: !checkIsAllowed(state?.user?.roles, [
                                    ROLE.SUPER_ADMIN,
                                ]),
                            })}
                        >
                            <P
                                className={cn("text-nowrap", {
                                    "text-blue font-medium": currentTab === 1,
                                })}
                            >
                                Re Assign
                            </P>
                        </div>
                    </div>
                    <div
                        className={cn(
                            "bg-linear-blue-white p-1.5 mt-3 mb-2 md:my-2   md:m-auto  md:py-2 gap-2 flex flex-col rounded-3xl  justify-center  items-center ",
                            {
                                hidden: currentTab !== 0,
                                "bg-blue-550": isProposalGenerated,
                            }
                        )}
                    >
                        <div className="flex w-full flex-col gap-0.5 xs:gap-1 justify-stretch">
                            <div className="flex justify-between items-center gap-2">
                                <div>
                                    <div className=" w-full ">
                                        <TextField
                                            label={""}
                                            value={propertyName}
                                            size={
                                                "w-full md:min-w-[24rem] bg-none !bg-transparent"
                                            }
                                            name="name"
                                            disabled={true}
                                            placeholder=""
                                            wrapper={
                                                "md:h-[5rem] px-0 !border-none !bg-none !bg-transparent"
                                            }
                                            inputWrapper="rounded-l-md px-0 py-0 md:p-1 text-xs !text-white !border-none !bg-none !bg-transparent text-clip "
                                            type="text"
                                            icon={<SlPencil />}
                                            iconWrapperClass={`py-[1.4rem] px-[1.5rem] !border-none text-white flex items-center rounded-r-md   `}
                                            iconChange={() => {
                                                setDis((prev) => !prev);
                                            }}
                                        />
                                    </div>
                                </div>
                                <Tag
                                    text={propertyId}
                                    className={" bg-gray-100 rounded-xl p-0.2"}
                                    icon={
                                        isProposalGenerated && (
                                            <img
                                                src={statusImages.hot}
                                                alt="fire"
                                                className="h-2"
                                            />
                                        )
                                    }
                                    textClass={
                                        "text-secondary  gap-0.5 text-nowrap !text-xs"
                                    }
                                />
                            </div>
                            <p className="text-white flex items-start  text-xs xsm:w-2/3 line-clamp-1">
                                <img
                                    src={locationLight}
                                    alt="locationLight"
                                    className="mt-0.2"
                                />{" "}
                                <p className="line-clamp-1 ml-1 break-all text-xs text-white">
                                    {formData?.siteAddress}
                                </p>
                            </p>
                        </div>
                        <div className="flex w-full items-center justify-between gap-1">
                            {isProposalGenerated ? (
                                <>
                                    <div className="flex flex-col items-start">
                                        <H4 className="text-xs xs:text-sm sm:text-nowrap text-white md:text-base xl:text-base ">
                                            {parseInt(totalUnits / 120)} KWp
                                        </H4>
                                        <P className=" text-xs text-nowrap text-white md:text-sm xl:text-sm">
                                            Plant Size
                                        </P>
                                    </div>
                                    <div
                                        className={`bg-blue-200 w-0.1 min-h-[5rem]  max-h-[6rem]
                                                                                `}
                                    />
                                    <div className="flex flex-col items-start">
                                        <H4 className="text-xs sm:text-nowrap xs:text-sm text-white md:text-base xl:text-base ">
                                            ₹ {consumersBill}
                                        </H4>
                                        <P className="text-xs text-nowrap text-white md:text-sm xl:text-sm ">
                                            Consumer's Bill
                                        </P>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {" "}
                                    <div className="flex flex-col items-start">
                                        <H4 className="text-xs xs:text-sm sm:text-nowrap text-white md:text-base xl:text-base ">
                                            ₹{" "}
                                            <Counter
                                                start={
                                                    Number(
                                                        formData?.monthlyElectricBill
                                                    ) - 200
                                                }
                                                value={
                                                    formData?.monthlyElectricBill
                                                }
                                            />
                                        </H4>
                                        <P className=" text-xs text-nowrap text-white md:text-sm xl:text-sm">
                                            Monthly Electricity Bill
                                        </P>
                                    </div>
                                    <div
                                        className={`bg-blue-200 w-0.1 min-h-[5rem]  max-h-[6rem]
                                                                                `}
                                    />
                                    <div className="flex flex-col items-start">
                                        <H4 className="text-xs sm:text-nowrap xs:text-sm text-white md:text-base xl:text-base ">
                                            {surveyD || ""}
                                        </H4>
                                        <P className="text-xs text-nowrap text-white md:text-sm xl:text-sm ">
                                            Survey Schedule
                                        </P>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </Container>

                <div
                    className={cn(
                        "lg:w-[50%] lg:bg-white lg:flex-col lg:rounded-3xl p-2 lg:border w-full lg:shadow-xl ",
                        {
                            "hidden lg:flex":
                                currentTab !== 0 || isProposalGenerated,
                        }
                    )}
                >
                    <GenerateProposal
                        isProposalGenerated={isProposalGenerated}
                        selectedConnectionType={selectedConnectionType}
                        onConnectionTypeChange={handleConnectionTypeChange}
                        consumersBill={consumersBill}
                        generateProposal={generateProposal}
                        totalUnits={totalUnits}
                        onTotalUnitsChange={handleTotalUnitsChange}
                        setIsOpen={setIsOpen}
                        planDuration={plan}
                        propertyList={[
                            {
                                label: "Residential Society",
                                value: "Residential Society",
                            },
                            { label: "Commercial", value: "Commercial" },
                            { label: "Industrial", value: "Industrial" },
                            {
                                label: "Individual Homes",
                                value: "Individual Homes",
                            },
                        ]}
                        handleConsumerBill={handleConsumerBill}
                        checkedState={checkedState}
                        handleCheckboxChange={handleCheckboxChange}
                        showAdditionalModal={showAdditionalModal}
                        onChangeAdditionalModal={() =>
                            setShowAdditionalModal((prev) => !prev)
                        }
                        ref={null}
                    />
                </div>
                <div
                    className={cn("lg:hidden", {
                        "hidden ": currentTab !== 1,
                    })}
                >
                    <ReAssignForm
                        surveyD={surveyDate}
                        details={details}
                        plantId={propertyId}
                    />
                </div>

                <div
                    className={cn("lg:w-[70%] ", {
                        hidden: !isProposalGenerated,
                    })}
                >
                    <ProposalTable
                        connectionType={
                            isProposalGenerated
                                ? selectedConnectionType
                                : "XXXX"
                        }
                        formData={formData}
                        planDuration={plan}
                        propertyName={propertyName}
                        setDis={setDis}
                        surveyD={surveyD}
                        additionalData={additionalInput}
                        totalUnits={isProposalGenerated ? totalUnits : "XXXX"}
                        consumersBill={
                            isProposalGenerated ? consumersBill : "XXXX"
                        }
                        currentTab={currentSlide}
                        setCurrentTab={setCurrentSlide}
                        subsidy={subsidy}
                        selectedOptions={
                            isProposalGenerated
                                ? selectedOptions
                                : ["Purchase", "Lease", "Loan"]
                        }
                        solarData={solarData}
                        isProposalGenerated={isProposalGenerated}
                        checkedState={
                            isProposalGenerated
                                ? checkedState
                                : {
                                      purchase: false,
                                      lease: false,
                                      loan: false,
                                  }
                        }
                    />
                </div>
                <div className="hidden lg:block">
                    <ModalAlt
                        isOpen={isOpen}
                        contentClass={"bg-white"}
                        onClose={() => {
                            setIsOpen((prev) => !prev);
                        }}
                        innerTimes={false}
                        topPadding={"20px"}
                    >
                        <div className="bg-white rounded-2">
                            <div className="bg-gray-100 p-1 rounded-lg mb-1 w-full text-center">
                                <P>Reassign</P>
                            </div>
                            <ReAssignForm
                                surveyD={surveyDate}
                                details={details}
                                plantId={propertyId}
                            />
                        </div>
                    </ModalAlt>
                </div>
                {!isProposalGenerated && (
                    <div className="hidden lg:flex justify-center p-2 w-full rounded-2xl bg-white shadow-xl border items-center">
                        <H4 className="text-secondary ">
                            Please Generate Proposal to see details
                        </H4>
                    </div>
                )}
            </div>
            <AdditionalInput
                displayMode={
                    document.body.clientWidth > 700 ? "modal" : "drawer"
                }
                onQuitModal={onQuitModal}
                onClose={setShowAdditionalModal}
                isOpen={showAdditionalModal}
                inputs={additionalInput}
                setInputs={setAdditionalInputs}
            />
        </div>
    );
};

export default PropertyContent;
